/**
 * Domain Adapter — Utility Networks (IEC 61970 CIM)
 *
 * Phase-2 deliverable. Not-yet-implemented; returns an explicit typed error.
 * See registry.ts `inferDomainFromSceneItem` for domain assignment rules:
 * pmtiles + style.tags includes "utility" → domain "utility".
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

export const CimUtilityAdapter: DomainAdapter = {
  domain: "utility",
  version: "1.0.0",
  standard: "IEC-61970-CIM",

  /**
   * Detects utility-network assets.
   * Matches `layerKind === "utility-network"`, pmtiles with "utility" tag, or
   * explicit domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "utility") return true;
    if (item.layerKind === "utility-network") return true;
    const tags = (item.style?.["tags"] as string[] | undefined) ?? [];
    return item.layerKind === "pmtiles" && tags.includes("utility");
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "utility",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
